import React from 'react';
// import './FreelanceProject.css';

const Freelance = () => {
  return (<>
    <div className="freelance-project-container">
      <header className="freelance-project-header">
        <h1>Website Development & Bug Hunting Project</h1>
        <p>Freelancing Case Study</p>
      </header>

      <section className="freelance-project-section">
      <h2> Project Overview</h2>
        <p>
          This freelance project involved building a full-featured website from scratch and conducting manual and automated testing to ensure stability, performance, and security. The client wanted a professional, bug-free business website with admin controls and SEO optimization.
        </p>
      </section>

      <section className="freelance-project-section">
        <h2> Client Requirements</h2>
        <ul>
          <li>Responsive, modern web design</li>
          <li>Admin dashboard for content management</li>
          <li>Secure login system</li>
          <li>Cross-browser & mobile compatibility</li>
          <li>Bug-free and tested system</li>
        </ul>
      </section>

      <section className="freelance-project-section">
        <h2>Technologies Used</h2>
        <ul>
          <li><strong>Frontend:</strong> React.js, HTML5, CSS3, Bootstrap</li>
          <li><strong>Backend:</strong> Node.js, Express</li>
          <li><strong>Database:</strong> MongoDB</li>
          <li><strong>Testing:</strong> Postman, Selenium, Lighthouse, Chrome DevTools</li>
          <li><strong>Deployment:</strong> Netlify</li>
        </ul>
      </section>

      <section className="freelance-project-section">
        <h2> Bug Hunting & Testing</h2>
        <ul>
          <li> Identified slow-loading scripts & optimized performance</li>
          <li> Fixed cross-browser layout bugs</li>
          <li> Lighthouse score: 95+ for performance and accessibility</li>
          <li> Used Selenium to automate form and navigation testing</li>
          <li> Manual test cases documented with screenshots</li>
        </ul>
      </section>

      <section className="freelance-project-section">
        <h2> Final Outcome</h2>
        <p>
          The project was completed in 2 weeks and delivered ahead of schedule. The client experienced a 35% increase in user retention and now uses the site as their primary digital platform. It’s fully mobile-optimized, SEO-friendly, and secure.
        </p>
      </section>

     
      

      <footer className="freelance-project-footer">
        <p> Available for freelance work – Let’s build your next digital project!</p>
      </footer>
    </div>
  </>);
};

export default Freelance;
